import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Compose class names, resolving Tailwind conflicts in favour of the last one.
 *
 * `clsx` handles conditionals and arrays; `twMerge` then discards earlier utilities
 * that the later ones override, so a component can accept a `className` prop that
 * genuinely wins over its own defaults rather than fighting them on specificity.
 */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
